// @flow
import * as React from 'react';
import Errors from 'lib/errors';
import { EmptyCard, Loader } from 'components';

export default class HandleError extends React.PureComponent<
  {
    requestStatus: RequestStatus,
    children?: React.Element<any>,
    render?: Function,
  },
  void
> {
  render() {
    const { requestStatus, children, render } = this.props;

    if (requestStatus === 'complete') {
      return typeof render === 'function' ? render() : children;
    }

    if (requestStatus === 'pending') {
      return (
        <EmptyCard>
          <Loader size="10em" thickness="0.9em" />
        </EmptyCard>
      );
    }

    if (Errors.isNetworkingError(requestStatus)) {
      return (
        <EmptyCard
          title="Network Error"
          message="You seem to have lost your connection"
        />
      );
    }

    if (Errors.isServerError(requestStatus)) {
      return (
        <EmptyCard>
          <EmptyCard.Title>Looks like the service is down.</EmptyCard.Title>
          <EmptyCard.Message>
            Contact{' '}
            <a href="mailto:support@powerreviews.com">
              support@powerreviews.com
            </a>{' '}
            and let us know.
            {/*<RetryButton onClick={retryGetContent} />*/}
          </EmptyCard.Message>
        </EmptyCard>
      );
    }

    console.error('Unknown application error: ', requestStatus);

    return (
      <EmptyCard>
        <EmptyCard.Title>Application Error</EmptyCard.Title>
        <EmptyCard.Message>
          Contact{' '}
          <a href="mailto:support@powerreviews.com">support@powerreviews.com</a>{' '}
          and let us know.
          {/*<RetryButton onClick={retryGetContent} />*/}
        </EmptyCard.Message>
      </EmptyCard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/__components__/ContentRequest.js